@use '@hevoio/hevo-ui-toolkit/styles/variables' as hevo-toolkit-variables;

.alertWrapper {
  margin-top:  hevo-toolkit-variables.$spacer * 2.5;
  display: flex;
  flex-direction: column;
  align-items: center;
  .icon {
    color: var(--light-text);
  }

  .text {
    display: flex;
    flex-direction: column;
    align-items: center;
    .subtext {
      margin-top:  hevo-toolkit-variables.$spacer * 0.6 !important;
    }
  }

  .scrollToTopButton {
    text-transform: uppercase;
  }
}
